import React from 'react';
interface LogoProps {
  className?: string;
  variant?: 'color' | 'light';
  /** Affiche la sur-ligne « Municipalité de » au-dessus du nom. */
  showKicker?: boolean;
}
const CREST = 'https://images.squarespace-cdn.com/content/v1/5b90111a25bf02d46807a1a3/1536169226663-WSJGDO26DXT29BBRLVGZ/image001.png?format=500w';

/**
 * Armoiries officielles de la Municipalité de Baie-Trinité, présentées en entier,
 * accompagnées du bloc-marque texte pour la lisibilité aux petites tailles.
 */
export function Logo({
  className = '',
  variant = 'color',
  showKicker = true
}: LogoProps) {
  const wordmark = variant === 'light' ? 'text-white' : 'text-ville-navy';
  const kicker = variant === 'light' ? 'text-ville-lime' : 'text-ville-blue';
  return <span className={`inline-flex items-center gap-3 ${className}`} data-id="element-1682" data-mp="hrycb04n0yv7">
      <span className={`inline-flex shrink-0 items-center ${variant === 'light' ? 'rounded-xl bg-white px-2 py-1 ring-1 ring-white/30' : ''}`} data-id="element-1683" data-mp="2yhc63z92gibw">
        <img src={CREST} alt="" aria-hidden="true" className="h-[52px] w-auto object-contain" data-id="element-1684" data-mp="1euhtw07ypu8w" />
      </span>

      <span className="flex flex-col leading-none" data-id="element-1685" data-mp="19y183co8jryz">
        {showKicker && <span className={`mb-1 text-[10px] font-semibold uppercase tracking-[0.18em] ${kicker}`} data-id="element-1686" data-mp="1nx9asfjlxi7x">
            Municipalité de
          </span>}
        <span className={`whitespace-nowrap text-[22px] font-extrabold tracking-tight ${wordmark}`} data-id="element-1687" data-mp="1xtm3ba3f1q13">
          Baie-Trinité
        </span>
        <span className="sr-only" data-id="element-1688" data-mp="1stzpayfrk5r8">Municipalité de Baie-Trinité</span>
      </span>
    </span>;
}